/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ListComponent} from '../../../../admin-shared/crud-components/list/list.component';
import {CrudConfig} from '../../../../admin-shared/interfaces/crud.config';
import {DAM_PERSON_FORM} from '../dam-person-forms.config';


@Component({
  selector: 'app-dam-person-list',
  templateUrl: '../../../../admin-shared/crud-components/list/list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DamPersonListComponent extends ListComponent<any> implements OnInit {

  config: CrudConfig = {
    uri: '/dam-person',
    columns: DAM_PERSON_FORM,
    defaultSortColumn: 'header',
    defaultSortDirection: 'asc',
    title: 'Персоны'
  };

  ngOnInit() {
    super.setConfig(this.config);
    super.ngOnInit();
  }
}
